module.exports = __webpack_public_path__ + "static/LJA Bolongaita.7e74016a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/LJA Bolongaita.jpg
// module id = 1221
// module chunks = 6166952557895